import React, { useEffect, FC, useCallback } from 'react';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { useHistory, useLocation } from 'react-router-dom';
import { Typography, Box } from '@material-ui/core';
import { Widget } from '@typeform/embed-react';
import { useQuery } from '@tanstack/react-query';
import { getBookings } from '../../../services';
import ChipInfo from '../../shared/chip-info';
import AuthorizedLayout from '../../shared/layout/AuthorizedLayout';
import { languageType } from '../../../types';
import {
  fetchBookingsHistory,
  fetchUser,
  selectUser,
  useAppDispatch,
} from '../../../store';
import { useStyles } from './styles';

const AssessmentPage: FC<{}> = () => {
  const [t, i18n] = useTranslation();
  const classes = useStyles();
  const history = useHistory();
  const dispatch = useAppDispatch();
  const { user } = useSelector(selectUser);
  const location = useLocation();
  const { refetch: refetchMyBookings } = useQuery(['my-bookings'], getBookings);

  const typeFormID =
    i18n.language === languageType.ENGLISH
      ? process.env.REACT_APP_TYPEFORM_WIDGET_EN
      : process.env.REACT_APP_TYPEFORM_WIDGET_DE;

  useEffect(() => {
    // workaround for refreshing my bookings
    setTimeout(() => {
      dispatch(fetchBookingsHistory());
      dispatch(fetchUser());
    }, 3000);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const onSubmit = useCallback(() => {
    refetchMyBookings();
    dispatch(fetchBookingsHistory());
    dispatch(fetchUser());

    history.push('/bookings');
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const { calendlyInviteeUri } = location.state;

  return (
    <AuthorizedLayout>
      <Box className={classes.contentContainer}>
        <Box className={classes.headerContainer}>
          <Box className={classes.titleWrapper}>
            <Typography variant="h3">
              {t('v2.wellbeingAssessment.header_label_title')}
            </Typography>
            <Box className={classes.infoBanner}>
              <ChipInfo
                type="info"
                text={t('v2.global.banner_label_languageInfo')}
              />
            </Box>
          </Box>
        </Box>
        <Box className={classes.frameContainer}>
          {user?.id && (
            <Widget
              id={typeFormID || ''}
              className={classes.widget}
              hidden={{
                userid: user?.id,
                calendlyuri: calendlyInviteeUri,
              }}
              medium="snippet"
              inlineOnMobile
              onSubmit={onSubmit}
            />
          )}
        </Box>
      </Box>
    </AuthorizedLayout>
  );
};

export default AssessmentPage;
